import { forwardRef } from "react";

export const CustomCheckbox = forwardRef(
  ({ className = "", checked, onChange, name, label, id, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-2 mb-1">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id={id}
            name={name}
            checked={checked}
            onChange={onChange}
            ref={ref}
            {...props}
            className={`
              h-4 w-4 rounded border
              border-gray-300 text-purple-500
              focus:ring-2 focus:ring-purple-500
              focus:ring-offset-2 focus:ring-offset-white
              disabled:cursor-not-allowed disabled:opacity-50
              ${className}
            `}
          />
          <label
            htmlFor={id}
            className="text-sm font-medium leading-none text-gray-900"
          >
            {label}
          </label>
        </div>
      </div>
    );
  },
);

// CustomCheckbox.displayName = "CustomCheckbox";
